import React, { useEffect, useState } from 'react';

const DynamicTable = ({ data }) => {
    const [columnWidths, setColumnWidths] = useState([]);

    const tableHead = data.length ? Object.keys(data[0]) : [];
    const tableData = data.map(item => Object.values(item));

    useEffect(() => {
        const calculateColumnWidths = () => {
            return tableHead.map((header, index) => {
                const columnData = [header, ...tableData.map(row => row[index])];
                const maxLength = Math.max(...columnData.map(text => text.toString().length));
                return Math.min(maxLength * 10, 200); // Set a max width of 200px for each column
            });
        };
        setColumnWidths(calculateColumnWidths());
    }, [data]);

    return (
        <>
            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                <thead>
                    <tr>
                        {tableHead.map((header, index) => (
                            <th key={index} >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>

                    {tableData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex} >
                                    {cell}
                                </td>
                            ))}
                        </tr>
                    ))}

                </tbody>
            </table>

            {/* <div style={styles.outerContainer}>
                <div style={styles.scrollContainer}>
                    <table style={styles.table}>
                        <thead style={styles.tableHead}>
                            <tr>
                                {tableHead.map((header, index) => (
                                    <th key={index} style={{ ...styles.headerCell, width: columnWidths[index] }}>
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, cellIndex) => (
                                        <td key={cellIndex} style={{ ...styles.cell, width: columnWidths[cellIndex] }}>
                                            {cell}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div> */}
        </>
    );
};

// const styles = {
//     outerContainer: {
//         margin: '10px 0',
//         padding: '10px',
//         border: '1px solid #ff9b44',
//         borderRadius: '10px',
//         backgroundColor: '#fff',
//     },
//     scrollContainer: {
//         overflowX: 'auto', // Horizontal scrolling
//     },
//     table: {
//         borderCollapse: 'collapse',
//         width: '100%',
//     },
//     tableHead: {
//         backgroundColor: '#fc6075',
//     },
//     headerCell: {
//         fontWeight: 'bold',
//         color: '#fff',
//         textAlign: 'center',
//         padding: '10px',
//         border: '1px solid #ddd',
//     },
//     cell: {
//         textAlign: 'center',
//         color: '#555',
//         padding: '8px',
//         border: '1px solid #ddd',
//         backgroundColor: '#fff',
//     },
// };

export default DynamicTable;